import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoadingService {
    private _displayLoadingBar: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public readonly displayLoadingBar: Observable<boolean> = this._displayLoadingBar.asObservable();
    private _requestsInProgress = 0;

    constructor() { }

    startLoading() {
        this._requestsInProgress++;
        if (this._requestsInProgress > 0)
            this._displayLoadingBar.next(true);
    }

    finishedLoading() {
        this._requestsInProgress--;
        if (this._requestsInProgress <= 0)
            this._displayLoadingBar.next(false);
    }

    shouldDisplayLoadingBar(): Observable<boolean> {
        return this.displayLoadingBar;
    }
}
